import { defineStore } from 'pinia'

const expiryDate = new Date()
expiryDate.setDate(expiryDate.getDate() + 7)

export const useCarbarStore = defineStore('carbar', {
	namespaced: true,
	state: () => ({
		header: {
			signUpUserType: 'personal',
			showMobileMenu: false,
			isSecurityNoticeCollapsed: false,
			securityNoticeHeight: 0,
		},
		message: {
			title: null,
			error: null,
			success: null,
		},
		vehicleCount: {
			subscription: 0,
			used: 0,
			new: 0,
		},
		disabledDates: {},

		// Novated Lease Promo
		novatedLeasePromo: {
			isPreselected: false,
		},
	}),
	getters: {},
	actions: {
		clearMessage() {
			this.message.title = null
			this.message.error = null
			this.message.success = null
		},
	},
	persist: {
		// Height is viewport-dependent — only persist collapsed preference.
		pick: ['header.isSecurityNoticeCollapsed'],
		storage: piniaPluginPersistedstate.cookies({
			sameSite: 'strict',
			expires: expiryDate,
		}),
	},
})
